//@@ Libs
import { createSelector } from '@reduxjs/toolkit'

export const goalsSelector = (s) => s.goals.data
export const getMainGoalSelector = createSelector(goalsSelector, (goals) => goals.find(({isPrimary}) => isPrimary))
export const getGoalsListSelector = createSelector(goalsSelector, (goals) => {
    return goals.filter(({isPrimary}) => !isPrimary)
  }
)
